module.exports = __webpack_public_path__ + "img/1.edd08d72.png";